import Login from 'modules/auth/login'
import React from 'react'

export default function LoginPage() {
    return <Login />
}
